var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main_container" }, [
      _c("div", { staticClass: "container-fluid edit-story-wrapper" }, [
        _c("div", { staticClass: "borderEditView" }, [
          _c("div", { staticClass: "panel-wrapper" }, [
            _c("div", { staticClass: "col" }, [_c("logicComponent")], 1)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e79b723", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e79b723","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/logicEditView.vue
// module id = null
// module chunks = 